import { createAsyncThunk } from '@reduxjs/toolkit';
import { baseURL } from '@custom/constant';

type TeleradiologistPayoutsPayload = {
  search?: string;
  limit?: number;
  pageNumber?: number;
  from?: string;
};

interface TeleradiologistPayoutsResponse {
  status: string;
  result: any;
  msg: string;
  loading: boolean;
  error: string;
}

const getTeleradiologistPayouts = createAsyncThunk<TeleradiologistPayoutsResponse, TeleradiologistPayoutsPayload>(
  'teleradiologistPayouts/getTeleradiologistPayouts',
  async (payload: TeleradiologistPayoutsPayload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();

      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');
      if (hospitalId) {
        queryParams.append('hospitalId', hospitalId);
      }

      if (payload.search) {
        queryParams.append('search', payload.search);
      }

      if (payload.limit) {
        queryParams.append('limit', payload.limit.toString());
      }

      if (payload.pageNumber) {
        queryParams.append('pageNumber', payload.pageNumber.toString());
      }

      if (payload.from) {
        queryParams.append('from', payload.from);
      }

      const queryString = queryParams.toString();
      const url = `${baseURL}/audit/getTeleRadioPayouts${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch teleradiology service prices');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch data');
    }
  }
);

export default getTeleradiologistPayouts;
